import { ReactElement, useEffect } from 'react';

type WrapperRouteComponentProps = {
    title: string;
    children: ReactElement;
};

/**
 * Wrapper component để quản lý title của các trang/module
 * @param title - Title sẽ hiển thị trên browser tab
 * @param children - Component con sẽ được render
 */
export default function WrapperRouteComponent({ title, children }: WrapperRouteComponentProps) {
    useEffect(() => {
        // Set document title khi component mount
        if (title) {
            document.title = `${title} - NezenX`;
        }

        // Cleanup function để reset title khi component unmount
        return () => {
            document.title = 'NezenX';
        };
    }, [title]);

    return children;
}

